import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useAuthLogin } from "@/shared/hooks";
import { Loading } from "../Loading/Loading";
export function LoginLayout(props) {
    const { children, ...rest } = props;
    const status = useAuthLogin(rest);
    return status === 'read' ? _jsx(_Fragment, { children: children }) : _jsx(Loading, {});
}
